<!--
 * @FileDescription: 文件上传
 * @Author: fanqixin
 * @Date: 2021-8-4 10:58:27
 * @LastEditors: fanqixin
 * @LastEditTime: 2021-8-4 10:58:27
 -->
<template>
	<el-dialog title="附件上传" :visible.sync="dialogVisible" :before-close="handleDialogClose" :close-on-click-modal="false" append-to-body>
		<el-form ref="ruleForm" :model="entity" :rules="rules" v-if="styleType === 'filing'" >
			<el-row :getter="10" style="margin-bottom: 30px;">
				<el-col :span="8" :offset="4" :pull="1">
					<el-form-item label="临时归档:" prop="tempArchive">
						<el-radio-group v-model="entity.tempArchive">
							<el-radio :label="true">是</el-radio>
							<el-radio :label="false">否</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-col>
				<el-col :span="8" :offset="4" :pull="1">
						<el-form-item label="预计归档日期:" prop="advanceArchiveDate"><el-date-picker placeholder="预计归档日期" v-model="entity.advanceArchiveDate"></el-date-picker></el-form-item>
				</el-col>
				<el-col :span="20" :offset="3">
					<el-form-item label="备注:" prop="remark">
						<el-input type="textarea" placeholder="请输入备注" v-model="entity.remark" maxlength="500" show-word-limit></el-input>
					</el-form-item>
				</el-col>
			</el-row>

		</el-form>

		<el-upload
			ref="upload"
			:action="uploadUrl"
			:headers="{ Authorization: localCache.get('USER_TOKEN') }"
			:auto-upload="false"
			:before-upload="fileBeforeUpload"
			:on-success="fileUploadSuccess"
			:on-error="fileUploadError"
			:on-remove="fileOnRemove"
			multiple
			:limit="multiple ? undefined : 1"
			drag
		>
			<i class="el-icon-upload"></i>
			<div class="el-upload__text">
				将文件拖到此处，或
				<em>点击上传</em>
			</div>
			<div class="el-upload__tip " slot="tip">
				<span v-if="noTypeLimit">可上传全部类型文件，单个文件不得超过{{this.maxSize}}M</span>
				<span v-else>只能上传{{ sourceSuffix }}文件，单个文件不超过{{this.maxSize}}M</span>
			</div>
		</el-upload>
		<template slot="footer">
			<el-row type="flex" justify="space-between">
				<div >
					<el-button  @click="removeAll" type="danger" icon="el-icon-delete">移除所有</el-button>
					<!-- <el-button @click="uploadSubmit" type="primary" icon="el-icon-upload2">全部上传</el-button> -->
				</div>
				<div>
					<el-button @click="uploadSubmit" type="primary" icon="el-icon-check">确&nbsp;定</el-button>
					<!-- <el-button type="primary" icon="el-icon-check" @click="confirm">确&nbsp;定</el-button> -->
					<el-button icon="el-icon-close" @click="close">关&nbsp;闭</el-button>
				</div>
			</el-row>
		</template>
	</el-dialog>
</template>

<script>
import localCache from '@/localCache';
import { isEqual, isEmpty } from '@/utils';
import lrz from 'lrz';
export default {
	name: 'file-uploader',
	props: {
		// 数据类型范围
		sourceType: {
			type: [Array, String],
			default: () => {
				return ['video', 'audio', 'image', 'word', 'excel', 'ppt', 'pdf', 'txt'];
			}
		},
		//common 普通上传类型  filing 归档上传
		styleType:{
			type:String,
			default:'common'
		},
		// 文件最大大小
		maxSize: {
			type: Number,
			default: 20
		},
		multiple: {
			type: Boolean,
			default: true
		},
		action:{
			type: String,
			default: 'longstron/base/doc/file/upload'
		}
	},
	data() {
		return {
      localCache: localCache,
			dialogVisible: false, // 弹窗是否显示
			fileList: [], // 文件清单
			// 文件后缀
			fileSuffix: {
				image: ['bmp', 'jpg', 'jpeg', 'png', 'gif'], // 图片
				word: ['doc', 'docx'],
				excel: ['xls', 'xlsx'],
				ppt: ['ppt', 'pptx', 'pptm'],
				pdf: ['pdf'],
				txt: ['txt'],
				video: ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v'], // 视频
				audio: ['mp3', 'wav', 'wmv'] // 音频
			},

			entity:{
				remark:null, //合同说明
				tempArchive:false,//是否临时归档
				advanceArchiveDate:null //预计归档日期
			},
			rules :{
				remark:[{
						validator: (rule, value, callback)=>{
						if (this.entity.tempArchive && isEmpty(value)) {
							return callback(new Error('请输入备注'))
						}else{
							return callback()
						}
					}
				}],
				advanceArchiveDate:[{
					validator: (rule, value, callback)=>{
						if (this.entity.tempArchive && isEmpty(value)) {
							return callback(new Error('请选择预计归档日期'))
						}else{
							return callback()
						}
					}
				}]
			}
		};
	},

	computed: {
		// 无类型限制条件
		noTypeLimit() {
			return isEqual(this.sourceType, Object.keys(this.fileSuffix));
		},
		// 文件类型后缀拼接
		sourceSuffix() {
			let arr = [];
			for (let i = 0, len = this.sourceType.length; i < len; i++) {
				let suffixes = this.fileSuffix[this.sourceType[i]];
				arr.push(suffixes.join('/'));
			}
			return arr.join('/');
		},
    uploadUrl() {
      return process.env.VUE_APP_URL + this.action;
    }
	},
	// 页面创建后
	created() {},
	methods: {
		/**
		 * @description: 打开弹窗
		 */
		open() {
			this.fileList = [];
			this.dialogVisible = true;
		},
		/**
		 * @description: 附件上传前效验
		 * @param {File} file 附件
		 */
		fileBeforeUpload(file) {
			// 文件类型限制
			let fileType = this.getFileType(file.name);
			let isMatch = this.sourceType.includes(fileType);
			if (!this.noTypeLimit && !isMatch) {
				this.$message.error('上传文件只能是 ' + this.sourceSuffix.toUpperCase() + ' 格式!');
				return false;
			}
			// 文件大小限制
			let isLt = file.size / 1024 / 1024 < this.maxSize;
			if (!isLt) {
				if (file.type !== 'image/png' && file.type !== 'image/jpeg' && file.type !== 'image/gif') {
					this.$message.error(`上传文件大小不能超过 ${this.maxSize}MB!`);
					return false;
				}
				return new Promise(resolve => {
					lrz(file, { quality: 1 }).then(rst => {
						isLt = rst.fileLen / 1024 / 1024 < this.maxSize;
						resolve(rst.file);
					});
				});
			}
			// 校验成功
			return true;
		},
		/**
		 * @description: 附件上传成功后的回调
		 * @param {Object} response 附件上传接口返回值
		 * @param {File} file 附件
		 * @param {Array} fileList 附件清单
		 */
		fileUploadSuccess(response, file, fileList) {
			if (response && response.code === '00000') {
				this.fileList.push(response.model);
				if (this.fileList.length == fileList.length) {
					this.confirm();
				}
			} else {
				let index = fileList.findIndex(obj => (obj.uid = file.uid));
				if (index > -1) {
					fileList.splice(index, 1);
				}
				this.$message.error({
					message: response.code + ' ：' + response.message,
					duration: 5 * 1000,
					showClose: true
				});
			}
		},
		/**
		 * @description: 附件上传失败后的回调
		 * @param {Object} err 附件上传接口返回值
		 * @param {File} file 附件
		 * @param {Array} fileList 附件清单
		 */
		fileUploadError(err, file, fileList) {
			this.$message.error({
				message: '文件上传失败！',
				duration: 5 * 1000,
				showClose: true
			});
		},
		/**
		 * @description: 移除附件
		 * @param {File} file 附件
		 * @param {File} fileList 附件清单
		 */
		fileOnRemove(file, fileList) {
			if (file.response && file.response.model) {
				let removeIndex = this.fileList.findIndex(obj => obj.id === file.response.model.id);
				if (removeIndex > -1) {
					this.fileList.splice(removeIndex, 1);
				}
			}
		},
		/**
		 * @description: 全部上传
		 */
		uploadSubmit() {
			if (this.styleType == "filing") {
				this.$refs['ruleForm'].validate(valid => {
					if (valid) {
						this.$refs['upload'].submit();
					}
				});
			}else{
				this.$refs['upload'].submit();
			}
		},
		/**
		 * @description: 移除全部
		 */
		removeAll() {
			this.$refs['upload'].clearFiles();
			this.fileList = [];
		},
		/**
		 * @description: 确定
		 */
		confirm() {
			if (this.fileList.length == 0) {
				this.$message.warning('请上传附件')
			}else{
				this.$refs['upload'].clearFiles();
				this.dialogVisible = false;
				if (this.styleType == "filing") {
					this.$emit('confirm', this.fileList,this.entity );
				}else{
					this.$emit('confirm', this.fileList);
				}
			}
		},
		/**
		 * @description: 关闭弹窗
		 * @param {Function} done 执行关闭
		 */
		handleDialogClose(done) {
			this.$refs['upload'].clearFiles();
			done();
		},
		/**
		 * @description: 关闭
		 */
		close() {
			this.$refs['upload'].clearFiles();
			this.dialogVisible = false;
		},
		/**
		 * @description: 根据文件名判断文件类型
		 * @param {String} fileName 文件名
		 */
		getFileType(fileName) {
			let suffix = fileName.substr(fileName.lastIndexOf('.') + 1).toLowerCase();
			for (let key in this.fileSuffix) {
				if (this.fileSuffix[key].includes(suffix)) {
					return key;
				}
			}
			return 'other';
		}
	}
};
</script>
<style lang="less" scoped>
.el-dialog__wrapper {
	& /deep/ .el-upload {
		width: 100%;
		.el-upload-dragger {
			width: 100%;
		}
	}
	& /deep/ .el-upload-list {
		overflow-y: auto;
		min-height: 160px;
		max-height: 315px;
		margin-top: 5px;
		padding-right: 2px;
		.el-upload-list__item {
			background-color: #f4f4f4;
		}
		.el-upload-list__item:hover {
			background-color: #eeeeee;
		}
	}
}
.flex-btw{
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
}
</style>
